<div class="legal-content">
  <div class="btns">
    <div class="button">
      <mat-icon fontIcon="Bosch-Ic-bookmark"></mat-icon>
      <a target="_blank" rel="noopener" [href]="useTermsLink" class="useTerm">{{
        termsUseText
      }}</a>
    </div>
    <div class="button" (click)="openModalImprint()">
      <mat-icon fontIcon="Bosch-Ic-information"></mat-icon>
      <a class="imprint">{{ imprintText }}</a>
    </div>
  </div>
  <p>© 2021 Bosch Integrated Solutions Brazil</p>
</div>
